
import { Link } from "react-router-dom";
import AkkhorLayout from "../../../layout/AkkhorLayout";
import List from "../../../component/List";
import QuanLyBangHang from "../bang-hang/QuanLyBangHang";


export default function DanhSachDuAn() {
    let params = 'orderby=id-asc';
    const columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "title", label: "Tên dự án", options: { filter: true, sort: true } },
        {
            name: "thumbnail", label: "Ảnh đại diện",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return value && value != '' ? <img src={value} style={{width:"150px"}}/> : ''
                },
            }
        },
        { name: "chudautu", label: "Chủ đầu tư", options: { filter: true, sort: true } },
        {
            name: "id", label: "Chi tiết",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <a className="btn btn-sm btn-primary text-white" target="_blank" href={"/xem-bang-hang/" + value}><i className="far fa-eye"></i> Xem chi tiết</a>
                },
            }
        },
        {
            name: "id", label: "Quản lý bảng hàng",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <QuanLyBangHang duan_id={value}/>
                },
            }
        },
        {
            name: "status", label: "Trạng thái",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(value == 1) return "Hoạt động"
                    if(value == 0) return "Ngừng hoạt động"
                    return null
                },
            }
        },
      
        { name: "datecreate", label: "Ngày tạo", }
    ];

    return (<AkkhorLayout idrole="du-an">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Danh sách dự án
                </li>
            </ul>
        </div>
        <List name="duan" idrole="du-an" params={params} title="" defaultLimit={50} serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
